import React from "react";
import IOrder_Item from "@models/IOrder_Item";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import ICatalog_Item from "@models/ICatalog_Item";
import INewOrder_Item from "@models/INewOrder_Item";

type Props = {
    orderItem?: INewOrder_Item;
    catalogItem?: ICatalog_Item;
};

export const PackQtyReverseViewer: React.FC<Props> = (props) => {
    const catalogItem = props.catalogItem;
    const qty = props.orderItem?.qty || 1;
    const packQty = catalogItem?.pack_qty || 1;
    const initQty = qty / packQty;

    console.log(props.catalogItem);
    console.log(props.orderItem);

    return (
        <div className={"PackQtyReverseViewer text-small"}>
            {catalogItem && catalogItem.has_pack_qty && (
                <div>
                    <div>
                        <OwLabel title={"pack_qty"} isBold={true} className={"me-2"} postText={":"} />
                        {packQty}
                    </div>
                    {catalogItem.price_per_pack ? null : (
                        <div className="d-flex">
                            <OwLabel title={"total_packs"} isBold={true} className={"me-2 no-wrap"} postText={":"} />
                            {qty / packQty}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
